export default __webpack_public_path__ + "static/arthrscopysetup-d728d3f9abdd85a50b4c7b2d2d0736ad.png";